// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"9":"a6679a36","214":"d5197e9a","419":"47eb094d","765":"b7cdaa22","774":"68691cf3","787":"7ae8ee7e","858":"14ad3ca6","935":"56212fd5","942":"6d8968de"}[chunkId] + ".chunk.js";
};